import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { Money } from "../../../schemas/schemas";

@Component({
    selector: 'money-renderer',
    template: `<span style="width: 100%;display: inline-block;text-align: right;">{{modelValue.Value | currency:'EUR':'symbol-narrow'}}<span>`
})
export class MoneyRendererComponent implements ICellRendererAngularComp {
    public params: any;
    public modelValue: Money;

    agInit(params: any): void {
        this.params = params;
        this.modelValue = this.params.value;
    }

    refresh(): boolean {
        return false;
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/grid/renderer/money-renderer.component.ts